"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntitySidInfo = void 0;
var use_entity_definition_named_1 = require("./use-entity-definition-named");
var title_case_1 = require("../utils/title-case");
var useEntitySidInfo = function (sid) {
  var _a = __read((sid || '').split('/'), 2),
    entityTypeSlug = _a[0],
    slug = _a[1];
  try {
    var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)((0, title_case_1.titleCase)(entityTypeSlug));
    return {
      definition: definition,
      slug: slug
    };
  } catch (_b) {
    throw new Error("Cannot derive entity definition / id from the sid '".concat(sid, "'"));
  }
  return null;
};
exports.useEntitySidInfo = useEntitySidInfo;